"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelState = void 0;
var ike_map_1 = require("../ike.map");
var form_metadata_1 = require("./form.metadata");
var FormModelState = /** @class */ (function () {
    function FormModelState(form) {
        this.frozen = false;
        this.fields = new ike_map_1.IkeMap();
        this._metadata = new form_metadata_1.FormModelMetadata(form);
    }
    Object.defineProperty(FormModelState.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelState.prototype, "revision", {
        get: function () {
            return this._revision;
        },
        set: function (value) {
            this._revision = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelState.prototype, "version", {
        get: function () {
            return this._version;
        },
        set: function (value) {
            this._version = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelState.prototype, "rootFormId", {
        get: function () {
            return this._rootFormId;
        },
        set: function (value) {
            this._rootFormId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelState.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelState.prototype, "displayName", {
        get: function () {
            return this._displayName;
        },
        set: function (value) {
            this._displayName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelState.prototype, "displayVersion", {
        get: function () {
            return this._displayVersion;
        },
        set: function (value) {
            this._displayVersion = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelState.prototype, "description", {
        get: function () {
            return this._description;
        },
        set: function (value) {
            this._description = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelState.prototype, "updatedAt", {
        get: function () {
            return this._updatedAt;
        },
        set: function (value) {
            this._updatedAt = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelState.prototype, "createdAt", {
        get: function () {
            return this._createdAt;
        },
        set: function (value) {
            this._createdAt = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelState.prototype, "updatedBy", {
        get: function () {
            return this._updatedBy;
        },
        set: function (value) {
            this._updatedBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelState.prototype, "v", {
        get: function () {
            return this._v;
        },
        set: function (value) {
            this._v = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelState.prototype, "metadata", {
        get: function () {
            return this._metadata;
        },
        set: function (value) {
            this._metadata = value;
        },
        enumerable: false,
        configurable: true
    });
    FormModelState.prototype.setDisplayName = function (displayName) {
        this.displayName = displayName;
    };
    FormModelState.prototype.setDisplayVersion = function (displayVersion) {
        this.displayVersion = displayVersion;
    };
    FormModelState.prototype.setDescription = function (description) {
        this.description = description;
    };
    FormModelState.prototype.getFieldValue = function (fieldId) {
        return this.fields.get(fieldId);
    };
    FormModelState.prototype.setFieldValue = function (fieldId, state) {
        if (this.frozen) {
            throw new Error("Field ".concat(fieldId, ": Writing frozen state."));
        }
        this.fields.set(fieldId, state);
    };
    return FormModelState;
}());
exports.FormModelState = FormModelState;
//# sourceMappingURL=form.state.js.map